import { render, staticRenderFns } from "./credit-notes.vue?vue&type=template&id=ec6d7c8e&"
import script from "./credit-notes.ts?vue&type=script&lang=ts&"
export * from "./credit-notes.ts?vue&type=script&lang=ts&"
import style0 from "./credit-notes.scss?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports